<template>
    <div class="card mt-3">
        <div class="card-header bg-success">
            <span style="color: white">Холат</span>
        </div>
        <div class="card-body">
            <ul class="list-group list-group-flush overflow-auto" style="max-height: 300px;">
                <li class="list-group-item text-center">
                    <div class="badge badge-secondary" v-if="asset.status==='AssignedToEvaluator'">{{$t("realEstate.status.assignedToEvaluator")}}</div>
                    <div class="badge badge-warning" v-else-if="asset.status==='NotFullyEvaluated'">{{$t("realEstate.status.notFullyEvaluated")}}</div>
                    <div class="badge badge-info" v-else-if="asset.status==='Evaluated'">{{$t("realEstate.status.evaluated")}}</div>
                    <div class="badge badge-success" v-else-if="asset.status==='Confirmed'">{{$t("realEstate.status.confirmed")}}</div>
                    <div class="badge badge-danger" v-else-if="asset.status==='Rejected'">{{$t("realEstate.status.rejected")}}</div>
                    <div class="badge badge-danger" v-else>{{$t("realEstate.status.pending")}}</div>
                    <div v-if="asset.status==='Confirmed'">Сана: {{asset.confirmedDate}}</div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="asset.appraiserReportEsp">Баҳоловчи тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Баҳоловчи тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="asset.directorActInvoiceEsp">Директор тамонидан Ҳисоб варак фактура (ЭЦП оркали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Директор тамонидан Ҳисоб варак фактура (ЭЦП орқали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="asset.directorReportEsp">Директор тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Директор тамонидан ҳисобот (ЭЦП оркали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="asset.espDto">Буюртмачи тамонидан Ҳисоб варак фактура(ЭЦП оркали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Буюртмачи тамонидан Ҳисоб варак фактура(ЭЦП оркали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center" v-if="asset.invoiceMib">
                    <span class="badge badge-success" v-if="asset.invoiceMib.invoiceMIbJsonDirector">{{asset.invoiceMib.invoiceMIbJsonDirector}}</span>
                    <span class="badge badge-success" v-if="asset.invoiceMib.invoiceMIbJsonClient">{{asset.invoiceMib.invoiceMIbJsonClient}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            asset: Object
        }
    }
</script>

<style scoped>

</style>